<!-- Department header -->
<app-dept-header></app-dept-header>
<!-- Department header -->

<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section class="course-listing" id="courses">

            <div class="section-content" *ngIf="selectedDegree.image !== null">
              <img src="{{selectedDegree.image}}" alt="{{selectedDegree.degree_name}}" class="add-margin deg-img">
            </div>

            <div class="row">
              <div class="col-md-9">
                <header><h2>{{selectedDegree.degree_name}}</h2></header>
              </div>
              <div class="col-md-3">
                <div class="deg-syllabus" *ngIf="selectedDegree.syllabus !== null">
                  <a href="{{selectedDegree.syllabus}}" target="_blank" class="btn btn btn-primary">
                    <span class="fa fa-download"></span> View Syllabus
                  </a>
                </div>
              </div>
            </div>

            <section id="course-list">
              <div class="table-responsive">
                <table class="table table-hover course-list-table tablesorter">
                  <thead>
                  <tr>
                    <th>Year</th>
                    <th>Semester</th>
                    <th>Code</th>
                    <th>Course</th>
                    <th class="starts">Status (core/Optional)</th>
                    <th class="length">Credit Value</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngIf="degreeCourseData.length == 0">
                    <th><h3>No courses available..</h3></th>
                  </tr>

                    <tr *ngFor="let course of degreeCourseData[0]?.courses">
                      <th>{{course?.deg_course.deg_year.year}}</th>
                      <th>{{course?.deg_course.deg_semester.semester}}</th>
                      <th class="course-title">{{course?.deg_course.course_code}}</th>
                      <th class="course-title">{{course?.deg_course.course_name}}</th>
                      <th class="course-category">{{course?.deg_course.deg_co_type.course_type}}</th>
                      <th>{{course?.deg_course.credits}}</th>
                    </tr>

                  </tbody>
                </table>
              </div>
            </section>
          </section><!-- /.course-listing -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">

          <div class="section-content" *ngIf="imgCollection.length > 0">
            <ng-image-slider #nav
                             [images]="imgCollection"
                             [infinite]="false"
                             [autoSlide]="1"
                             [imageSize]="{width: 350, height: 350}"
                             slideImage="1"></ng-image-slider>
          </div>

          <aside class="news-small" id="news-small">
            <header>
              <h3>All Degrees</h3>
            </header>
            <div class="section-content">
              <article *ngFor="let degree of degreeData">
                <figure class="date"><a routerLink="/degreedet/{{degree.id}}"><img src="{{degree.image}}" class="deg-img"></a></figure>
                <header><a routerLink="/degreedet/{{degree.id}}">{{degree.degree_name}}</a></header>
              </article><!-- /article -->
            </div><!-- /.section-content -->
          </aside><!-- /.news-small -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
      <!-- end SIDEBAR Content-->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
